/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable quote-props */
/* eslint-disable object-curly-newline */
import Box from '@mui/material/Box';
import Typography from '@digital-hig/typography';
import { useTranslation } from 'react-i18next';
import { Popover } from '@mui/material';
import SRPStateInterface from '../../../common/context/srpInterface';
import { RootContainer, RightRootElement, FilterListingContainer } from './style';
import Listing from '../Listing';
import FilterBadges from '../Filters/FilterBadges';
import { SRPContext } from '../../../common/context/srpContext';
import Filters from '../Filters';
import { isMobileDevice } from '../../../utils/srp.util';
import Sorting from '../Sorting';
import ACTIONS_TYPE from '../../../common/context/actionType';

const Partners = () => {
  const [toggle, setToggle] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation('listing');
  const { listPartners, loading, dispatch, fetchPartnersData, sortListBy, filters, getAppliedMapFilter } = useContext(SRPContext);
  const { partners, pagination } = listPartners || SRPStateInterface.listPartners;

  const sortByObj = {
    'Relevancy': 'relevance',
    'Alphabetical': 'display_name',
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setToggle((prevState) => !prevState);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setToggle(false);
  };
  const handleSortChange = async (value) => {
    dispatch({ type: ACTIONS_TYPE.SET_SORTING, payload: sortByObj[value] });
    const selectedFilter = getAppliedMapFilter(filters);
    await fetchPartnersData({
      search: selectedFilter,
      sortBy: sortByObj[value],
    });
  };

  const sortValue = Object.entries(sortByObj).find(
    ([, value]) => value === sortListBy,
  )?.[0] || 'Relevancy';

  return (
    <RootContainer>
      <Box className="page-container">
        {(loading || partners?.length !== 0) && (
          <Typography
            variant="headline-medium"
            className="partner-heading"
            component="h2"
          >
            {t('Partners')}
          </Typography>
        )}
        <Box className="filter-row">
          <FilterBadges
            isToggle={toggle}
            handleToggle={handleClick}
          />
          <RightRootElement>
            <div className="filter-totalPartners">
              {pagination?.total_count !== undefined && (
                <>
                  <Typography>{pagination?.total_count}</Typography>
                  <Typography>
                    {' '}
                    {t('Partners')}
                  </Typography>
                </>
              )}
            </div>
            <Sorting
              totalPartners={partners?.length || 0}
              handleSortChange={handleSortChange}
              sortValue={sortValue}
            />
          </RightRootElement>
        </Box>
      </Box>
      <FilterListingContainer className="page-container display-flex">
        {!isMobileDevice()
        && (
          <Box className={`filter-section ${!toggle ? 'animation' : ''}`}>
            <Filters />
          </Box>
        )}
        {isMobileDevice() && (
          <Popover
            open={toggle}
            anchorEl={anchorEl}
            onClose={handleClose}
            slotProps={{
              paper: {
                sx: {
                  borderRadius: '0px !important',
                  height: '100% !important',
                  left: '0 !important',
                  maxWidth: '100% !important',
                  maxHeight: '100% !important',
                  width: '100% !important',
                  border: '1px solid #e5e5e5',
                  borderBottom: '2px solid #656565',
                  boxShadow: 'none !important',
                  top: '0 !important',
                  marginTop: '0 !important',
                },
              },
              root: {
                sx: {
                  zIndex: '9999',
                },
                slotProps: {
                  backdrop: {
                    sx: {
                      background: {
                        md: 'none',
                        sm: 'rgba(0, 0, 0, 0.8)',
                      },
                      opacity: {
                        md: 1,
                        sm: 0.8,
                      },
                      zIndex: {
                        md: 0,
                        sm: -1,
                      },
                    },
                  },
                },
              },
            }}
          >
            <Filters handleClose={handleClose} />
          </Popover>
        )}
        <Box className={`card-section ${toggle ? 'filter-active' : ''}`}>
          <Listing isFilter={toggle} />
        </Box>
      </FilterListingContainer>
    </RootContainer>
  );
};

export default Partners;
